import React from 'react'
// Lightbox imports
import Lightbox from 'yet-another-react-lightbox/dist/index'
import 'yet-another-react-lightbox/dist/styles.css'
import Zoom from 'yet-another-react-lightbox/dist/plugins/zoom'
import Counter from 'yet-another-react-lightbox/dist/plugins/counter'
import 'yet-another-react-lightbox/dist/plugins/counter/counter.css'
import PropTypes from 'prop-types'

const LightBox = props => {
  const { images, openSlideShow, setOpenSlideShow, index } = props
  return (
    <Lightbox
      open={openSlideShow}
      close={() => setOpenSlideShow(false)}
      slides={images.map(src => ({ src }))}
      // Which slide to open on. It was pinned to 0, which is right for a "View all" button and
      // wrong for tapping one photo in a list — the caller says, and 0 stays the default.
      index={index || 0}
      plugins={[Counter, Zoom]}
    />
  )
}

LightBox.propTypes = {
  images: PropTypes.array,
  openSlideShow: PropTypes.bool,
  setOpenSlideShow: PropTypes.func,
  index: PropTypes.number
}

export default LightBox
